import { render } from "./NotFoundView.vue?vue&type=template&id=f1ce1686&scoped=true"
import script from "./NotFoundView.vue?vue&type=script&lang=js"
export * from "./NotFoundView.vue?vue&type=script&lang=js"

import "./NotFoundView.vue?vue&type=style&index=0&id=f1ce1686&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1ce1686"]])

export default __exports__